import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaTwitter, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });

  const footerLinks = [
    {
      heading: 'Pages',
      links: [
        { name: 'Home', path: '/' },
        { name: 'Our Story', path: '/story' },
        { name: 'Products', path: '/products' },
        { name: 'Recipes', path: '/recipes' },
        { name: 'Blogs', path: '/blogs' },
        { name: 'Contact', path: '/contact' },
      ],
    },
    {
      heading: 'Categories',
      links: [
        { name: 'Signature Spice Blends', path: '/products' },
        { name: 'Chef’s Ready Mix', path: '/products' },
        { name: 'Luxury Spice Range', path: '/products' },
        { name: 'Farm Fresh Spices', path: '/products' },
        { name: 'World Spice Series', path: '/products' },
      ],
    },
    {
      heading: 'Support',
      links: [
        { name: 'FAQs', path: '/faqs' },
        { name: 'Contact Us', path: '/contact' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Terms & Conditions', path: '/terms' },
        { name: 'Sitemap', path: '/sitemap' },
      ],
    },
  ];

  return (
    <footer className="footer" ref={ref}>
      <div className="container">
        {/* Big text */}
        <motion.div
          className="footer-big-text"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="footer-brand-primary">Ragini</span>
          <span className="footer-brand-filled gradient-text">Masale</span>
        </motion.div>

        {/* Grid */}
        <motion.div
          className="footer-grid"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {/* Brand */}
          <div className="footer-brand">
            <p className="footer-desc">
              Crafting heritage spice blends since 2005. Hand-picked, stone-ground, and delivered with purity.
            </p>
            <div className="footer-socials">
              <a href="https://instagram.com" className="social-link" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://facebook.com" className="social-link" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://twitter.com" className="social-link" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://youtube.com" className="social-link" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </div>

          {/* Links Column Mapping */}
          {footerLinks.map((col) => (
            <div key={col.heading} className="footer-col">
              <h4 className="footer-col-heading">{col.heading}</h4>
              <ul>
                {col.links.map((l) => (
                  <li key={l.name}>
                    <Link to={l.path} className="footer-link">{l.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter */}
          <div className="footer-newsletter">
            <h4 className="footer-col-heading">Stay Spiced</h4>
            <p className="footer-newsletter-text">Join our community for seasonal recipes and stories.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Your email" className="newsletter-input" />
              <button className="newsletter-btn">→</button>
            </div>
          </div>
        </motion.div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>© 2024 Ragini Masale. Crafted with Heritage.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/sitemap">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
